import { BreadcrumbList, WithContext } from 'schema-dts';

export interface BreadcrumbItem {
  name: string;
  path: string;
}

export function generateBreadcrumbSchema(
  items: BreadcrumbItem[],
  baseUrl: string = process.env.NEXT_PUBLIC_SITE_URL || 'https://yunovaint1810.builtwithrocket.new'
): WithContext<BreadcrumbList> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${baseUrl}${item.path}`,
    })),
  };
}

// Pre-configured breadcrumb paths for common pages
export const breadcrumbPaths = {
  home: [{ name: 'Home', path: '/' }],
  destinations: [
    { name: 'Home', path: '/' },
    { name: 'Study Destinations', path: '/destinations' },
  ],
  destinationDetail: (countryName: string, countryId: string) => [
    { name: 'Home', path: '/' },
    { name: 'Study Destinations', path: '/destinations' },
    { name: countryName, path: `/destinations/${countryId}` },
  ],
  blog: [
    { name: 'Home', path: '/' },
    { name: 'Blog', path: '/blog' },
  ],
  blogDetail: (postTitle: string, postId: string) => [
    { name: 'Home', path: '/' },
    { name: 'Blog', path: '/blog' },
    { name: postTitle, path: `/blog/${postId}` },
  ],
  services: [
    { name: 'Home', path: '/' },
    { name: 'Services & Pricing', path: '/services-overview' },
  ],
  aboutUs: [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about-us' },
  ],
  contact: [
    { name: 'Home', path: '/' },
    { name: 'Contact Us', path: '/contact' },
  ],
  consultation: [
    { name: 'Home', path: '/' },
    { name: 'Book Consultation', path: '/consultation-booking' },
  ],
  otpLogs: [
    { name: 'Home', path: '/' },
    { name: 'OTP Logs', path: '/otp-logs' },
  ],
  thankYou: [
    { name: 'Home', path: '/' },
    { name: 'Thank You', path: '/thank-you-page' },
  ],
};
